/**
 * Client-side JavaScript: Filter Bar & Multi-Dimensional Filter Logic
 *
 * Renders a filter bar with search + status chips + filter icon on the main bar.
 * Type and File filters render inside a separate filter drawer.
 * Manages filter state and applies filtering via re-rendering.
 * OR logic within dimensions, AND logic across dimensions, plus text search.
 */

export const JS_FILTERS = `
var _filterState={status:{},type:{},specFile:{}};
var _totalTests=0;
var _originalSummary=null;

function renderFilterBar(){
  var filterEl=document.getElementById('filter-bar');
  var drawerBodyEl=document.getElementById('filter-drawer-body');
  var statusCounts={passed:0,failed:0,flaky:0,skipped:0,timedout:0};
  var typeCounts={},specCounts={};
  for(var i=0;i<tests.length;i++){
    var t=tests[i];
    if(statusCounts[t.status]!==undefined)statusCounts[t.status]++;
    var tp=t.testType||'unknown';
    typeCounts[tp]=(typeCounts[tp]||0)+1;
    if(t.filePath)specCounts[t.filePath]=(specCounts[t.filePath]||0)+1;
  }
  var hasStatus=Object.keys(_filterState.status).length>0;
  var hasType=Object.keys(_filterState.type).length>0;
  var hasSpec=Object.keys(_filterState.specFile).length>0;
  var hasAny=hasStatus||hasType||hasSpec||!!searchQuery;
  var hasAdvanced=hasType||hasSpec;

  /* ── Filter Bar (search + status chips + filter icon) ── */
  var h='';

  /* Search box (left-aligned, wider) */
  h+='<div class="search-box"><svg class="search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg><input class="search-input" id="search-input" type="text" placeholder="Search tests..." value="'+esc(searchQuery)+'"></div>';

  /* Status chips (inline) */
  h+='<div class="filter-chips">';
  var statuses=['passed','failed','flaky','skipped','timedout'];
  var statusLabels={passed:'Passed',failed:'Failed',flaky:'Flaky',skipped:'Skipped',timedout:'Timed Out'};
  for(var i=0;i<statuses.length;i++){
    var s=statuses[i];var cnt=statusCounts[s]||0;
    var cls='filter-chip'+(!!_filterState.status[s]?' active':'')+(cnt===0?' filter-chip--dimmed':'');
    h+='<button class="'+cls+'" data-dimension="status" data-value="'+s+'">'+statusLabels[s]+' <span class="chip-count">'+cnt+'</span></button>';
  }
  h+='</div>';

  /* Filter icon button */
  h+='<button class="filter-icon-btn" title="More filters">';
  h+='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/></svg>';
  if(hasAdvanced)h+='<span class="filter-icon-badge"></span>';
  h+='</button>';

  if(filterEl)filterEl.innerHTML=h;

  /* ── Filter Drawer Body (type + file + actions) ── */
  var d='';

  /* Type section */
  var types=Object.keys(typeCounts).sort();
  if(types.length>0){
    d+='<div class="filter-drawer-section"><span class="filter-drawer-section-label">Type</span>';
    d+='<div class="filter-chips">';
    for(var i=0;i<types.length;i++){
      var tp=types[i];var cnt=typeCounts[tp]||0;
      var cls='filter-chip'+(!!_filterState.type[tp]?' active':'')+(cnt===0?' filter-chip--dimmed':'');
      d+='<button class="'+cls+'" data-dimension="type" data-value="'+esc(tp)+'">'+esc(tp)+' <span class="chip-count">'+cnt+'</span></button>';
    }
    d+='</div></div>';
  }

  /* Spec file section */
  var specs=Object.keys(specCounts).sort();
  if(specs.length>1){
    d+='<div class="filter-drawer-section"><span class="filter-drawer-section-label">File</span>';
    d+='<div class="filter-chips">';
    for(var i=0;i<specs.length;i++){
      var sp=specs[i];var cnt=specCounts[sp]||0;
      var short=sp.split('/').pop()||sp;
      var cls='filter-chip'+(!!_filterState.specFile[sp]?' active':'')+(cnt===0?' filter-chip--dimmed':'');
      d+='<button class="'+cls+'" data-dimension="specFile" data-value="'+esc(sp)+'" title="'+esc(sp)+'">'+esc(short)+' <span class="chip-count">'+cnt+'</span></button>';
    }
    d+='</div></div>';
  }

  /* Actions (Clear all + indicator) */
  d+='<div class="filter-drawer-actions">';
  d+='<button class="filter-clear" id="filter-clear" style="display:'+(hasAny?'inline-block':'none')+'">Clear all</button>';
  d+='<span class="filter-indicator" id="filter-indicator" style="display:'+(hasAny?'inline':'none')+'">';
  d+='Showing <span id="filter-shown">0</span> of <span id="filter-total">'+_totalTests+'</span> tests</span>';
  d+='</div>';

  if(drawerBodyEl)drawerBodyEl.innerHTML=d;
}

function initFilters(){
  _filterState={status:{},type:{},specFile:{}};
  _totalTests=tests.length;
  _originalSummary={total:data.summary.total,passed:data.summary.passed,
    failed:data.summary.failed,flaky:data.summary.flaky,
    skipped:data.summary.skipped,timedout:data.summary.timedout||0};
}

function getFilteredTests(){
  var hasStatus=Object.keys(_filterState.status).length>0;
  var hasType=Object.keys(_filterState.type).length>0;
  var hasSpec=Object.keys(_filterState.specFile).length>0;
  var out=[];
  for(var i=0;i<tests.length;i++){
    var t=tests[i];
    if(hasStatus&&!_filterState.status[t.status])continue;
    if(hasType&&!_filterState.type[t.testType||'unknown'])continue;
    if(hasSpec&&!_filterState.specFile[t.filePath])continue;
    if(searchQuery){
      var q=searchQuery.toLowerCase();
      var match=t.title.toLowerCase().indexOf(q)>=0||t.filePath.toLowerCase().indexOf(q)>=0||(t.suiteName&&t.suiteName.toLowerCase().indexOf(q)>=0);
      if(!match&&t.tags){for(var ti=0;ti<t.tags.length;ti++){if(t.tags[ti]&&t.tags[ti].toLowerCase().indexOf(q)>=0){match=true;break}}}
      if(!match)continue;
    }
    out.push(t);
  }
  return out;
}

function toggleFilter(dim,val){
  if(!_filterState[dim])_filterState[dim]={};
  if(_filterState[dim][val]){
    delete _filterState[dim][val];
  }else{
    _filterState[dim][val]=true;
  }
  applyFilters();
}

function clearAllFilters(){
  _filterState={status:{},type:{},specFile:{}};
  searchQuery='';
  var si=document.getElementById('search-input');
  if(si)si.value='';
  applyFilters();
}

function applyFilters(){
  renderFilterBar();
  renderTestGrid();
  var hasStatus=Object.keys(_filterState.status).length>0;
  var hasType=Object.keys(_filterState.type).length>0;
  var hasSpec=Object.keys(_filterState.specFile).length>0;
  var hasAny=hasStatus||hasType||hasSpec||!!searchQuery;
  if(hasAny){
    var filtered=getFilteredTests();
    var byStatus={passed:0,failed:0,flaky:0,skipped:0,timedout:0};
    for(var i=0;i<filtered.length;i++){
      var st=filtered[i].status;
      if(byStatus[st]!==undefined)byStatus[st]++;
    }
    _updateCard('s-total',filtered.length);
    _updateCard('s-passed',byStatus.passed);
    _updateCard('s-failed',byStatus.failed);
    _updateCard('s-flaky',byStatus.flaky);
    _updateCard('s-skipped',byStatus.skipped);
    _updateCard('s-timedout',byStatus.timedout);
    var shown=document.getElementById('filter-shown');
    if(shown)shown.textContent=''+filtered.length;
  }else if(_originalSummary){
    _updateCard('s-total',_originalSummary.total);
    _updateCard('s-passed',_originalSummary.passed);
    _updateCard('s-failed',_originalSummary.failed);
    _updateCard('s-flaky',_originalSummary.flaky);
    _updateCard('s-skipped',_originalSummary.skipped);
    _updateCard('s-timedout',_originalSummary.timedout);
  }
}

function _updateCard(cls,val){
  var el=document.querySelector('.'+cls+' .s-count');
  if(el)el.textContent=''+val;
}
`;
